// Signed URLs and renewal context are ephemeral UI data, never saved game state.
import config from '../config';
import { localDebugEnabled } from './localDebug';
import { alphaClient } from '../cdo/shared/playerTransport';
const references = new Map();
export const mediaSource = (media, size = 'display') => {
  const src = media?.[size === 'card' ? 'thumbnailUrl' : size === 'original' ? 'originalUrl' : 'displayUrl'];
  if (src && /^https:\/\//.test(src)) {
    for (const key of ['thumbnailUrl', 'displayUrl', 'originalUrl']) {
      if (media[key]) {
        if (references.size >= 2048) references.delete(references.keys().next().value);
        references.set(media[key], media);
      }
    }
    return src;
  }
  return media?.mediaBase64 ? `data:${media.mediaType || 'image/png'};base64,${media.mediaBase64}` : '';
};
export const mediaDisplaySource = src => references.get(src)?.displayUrl || src;
export const refreshMediaSource = async (src, size = 'display') => {
  const media = references.get(src);
  if (!/^\/(?:(api|local)\/worlds\/[a-f0-9-]{36}|authoring\/media)\/(being\/select-portrait-images|place\/select-approach-image)\?idEntity=[a-f0-9-]{36}$/i.test(media?.mediaRefreshPath || '')) return '';
  let path = media.mediaRefreshPath;
  if (alphaClient && window.location.pathname === '/admin' && path.startsWith('/authoring/')) {
    path = `/api/admin${path}`;
  } else if (path.startsWith('/local/') || path.startsWith('/authoring/')) {
    if (!localDebugEnabled() || !['localhost', '127.0.0.1', '[::1]'].includes(new URL(config.server.url).hostname)) return '';
    path = `${config.server.url}:${config.server.webServicesPort}${path}`;
  }
  const response = await fetch(path, { credentials: 'same-origin', cache: 'no-store' });
  if (!response.ok) throw new Error('Image access could not be refreshed.');
  const result = await response.json();
  const updated = Array.isArray(result) ? result.find(row => String(row.idEntityMedia) === String(media.idEntityMedia)) : result;
  return mediaSource(updated, size);
};
